
export const LOAD_ORDER_CONFIRMATION = 'atlas/Confirm/LOAD_ORDER_CONFIRMATION';
export const LOAD_ORDER_CONFIRMATION_SUCCESS = 'atlas/Confirm/LOAD_ORDER_CONFIRMATION_SUCCESS';
export const LOAD_ORDER_CONFIRMATION_ERROR = 'atlas/Confirm/LOAD_ORDER_CONFIRMATION_ERROR';
export const LOAD_QUOTE_CONFIRMATION = 'atlas/Confirm/LOAD_QUOTE_CONFIRMATION';